import PersonOutline from '@mui/icons-material/PersonOutline';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import type { NavItemProps } from '../CustomNavLink';
import theme from '../../../../themes/theme';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';

const Profile = ({ ActiveComp }: NavItemProps) => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  return (<Box
    sx={(theme) => ({
      alignItems: 'center',
      borderLeft: `1px solid ${theme.palette.divider}`,
      color: ActiveComp ? theme.palette.primary.main : 'inherit',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      padding: '1rem',
    })}
  >
    <IconButton size="small" edge="end"   sx={{
          color: isAuthenticated ? theme.palette.primary.contrastText : 'inherit',
          // Signed in, the icon is white on a pink disc. Under the mouse MUI
          // swaps the disc for a faint wash (its own IconButton rule, as it
          // always has), and on the white header card a white icon is lost
          // on it. So under the mouse the icon takes the disc's pink: 3.57:1
          // on the wash. The wash, and the rest of the hover, are MUI's.
          ...(isAuthenticated && { '&:hover': { color: theme.palette.secondary.main } }),
          backgroundColor: isAuthenticated ?  theme.palette.secondary.main : 'transparent', 
        }}>
      <PersonOutline />
    </IconButton>
    {ActiveComp && <ActiveComp />}
  </Box>)
};

export default Profile;
